"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.addFeatures = exports.loadFeatures = undefined;

var _extends2 = require("babel-runtime/helpers/extends");

var _extends3 = _interopRequireDefault(_extends2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Actions
var prefix = "FEATURE_TOGGLE/";
var LOAD_FEATURES = prefix + "LOAD_FEATURES";
var ADD_FEATURES = prefix + "ADD_FEATURES";

var loadFeatures = exports.loadFeatures = function loadFeatures(payload) {
  return {
    type: LOAD_FEATURES,
    payload: payload
  };
};

var addFeatures = exports.addFeatures = function addFeatures(payload) {
  return {
    type: ADD_FEATURES,
    payload: payload
  };
};

// Reducer
var createFeatureToggleReducer = function createFeatureToggleReducer() {
  var initialState = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return function (state) {
    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    switch (action.type) {
      case LOAD_FEATURES:
        return action.payload;
      case ADD_FEATURES:
        return (0, _extends3.default)({}, state, action.payload);
      default:
        return state || initialState;
    }
  };
};

exports.default = createFeatureToggleReducer;